<div class="card card-redlaboral m-4">
    <div class="card-body">
        <div class="row">
            <div class="col-xxl-6 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <h4 class="mt-0 mb-0 text-primary">
                    <i class="fa-solid fa-table"></i>
                    Niveles Formativos
                </h4>
            </div>
            <div class="col-xxl-6 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            </div>
        </div>
        <div class="d-flex align-items-end mt-3">
            <app-search-filter
                [data]="EducationLevelsList"
                [field]="'name'"
                label="Buscar"
                placeholder="Buscar..."
                (filteredData)="filteredData = $event">
            </app-search-filter>
            <div class="ms-3">
                <button type="button" class="btn btn-success" (click)="openModal('', 'add', 'Agregar')">
                    <i class="fa-solid fa-plus"></i>
                    Agregar
                </button>
            </div>
        </div>
        <hr class="mt-3 mb-3" />
        <div class="table-responsive">
            <table class="table table-theme">
                <thead>
                    <tr>
                        <th class="text-start">Descripción</th>
                        <th class="text-center" width="110px">Activo</th>
                        <th class="text-center" width="110px">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    @for(item of pagedData; track item)
                    {
                        <tr>
                            <td class="text-start">{{item.name}}</td>
                            <td class="text-center">
                                <i class="fa-solid fa-check-circle text-success" *ngIf="item.isEnabled"></i>
                                <i class="fa-solid fa-times-circle text-danger" *ngIf="!item.isEnabled"></i>
                            </td>
                            <td class="text-center">
                                @if(item.isEnabled) {
                                    <button
                                        type="button"
                                        class="btn btn-primary btn-sm me-2"
                                        title="Editar"
                                        (click)="openModal(item, 'edit', 'Editar')">
                                        <i class="fa-solid fa-pencil"></i>
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-outline-danger btn-sm me-2"
                                        title="Eliminar"
                                        (click)="openModal(item, 'delete', 'Eliminar')">
                                        <i class="fa-solid fa-trash-can"></i>
                                    </button>
                                }
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
        <app-pagination
            [data]="filteredData"
            [pageSize]="pageSize"
            (paginatedData)="pagedData = $event"
            (pageSizeChange)="onPageSizeChange($event)">
        </app-pagination>
    </div>
</div>